import { StripePaymentElementOptions } from '@stripe/stripe-js'

export const VISITOR_PARKING_TOKEN_URL_KEY = 'token'
export const VISITOR_PARKING_TICKET_NUMBER_URL_KEY = 'ticketNumber'
export const VISITOR_PARKING_FREE_URL_KEY = 'free'
export const VISITOR_PARKING_CURRENCY = 'usd'

export const VISITOR_PARKING_SCREENS = {
  DURATION: 'DURATION',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
  SUMMARY: 'SUMMARY',
  VISITOR_DETAILS: 'VISITOR_DETAILS',
  WELCOME: 'WELCOME',
}

export type VisitorParkingScreens =
  (typeof VISITOR_PARKING_SCREENS)[keyof typeof VISITOR_PARKING_SCREENS]

export const EXTEND_VISITOR_PARKING_SCREENS = {
  EXTEND_DURATION: 'EXTEND_DURATION',
  PAYMENT: 'PAYMENT',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
  SESSION_DETAILS: 'SESSION_DETAILS',
}

export type ExtendVisitorParkingScreens =
  (typeof EXTEND_VISITOR_PARKING_SCREENS)[keyof typeof EXTEND_VISITOR_PARKING_SCREENS]

export const STRIPE_PAYMENT_ELEMENT_OPTIONS: StripePaymentElementOptions = {
  layout: 'tabs',
  wallets: {
    applePay: 'auto',
    googlePay: 'auto',
  },
}
